module.exports = __webpack_public_path__ + "media/images/lp/lp21-39baa27e24c0aed40e31d35ae86e7cc6.webp";